module.exports = __webpack_public_path__ + "static/EnmTX_BosSimeon_L_B_cl-431c027001b21d4d9f4be541d9c96a6c.gif";